import { formatDateToDDMMYYYY } from '@/fsd/shared/lib/helpers/formatDateToDDMMYYYY/formatDateToDDMMYYYY';
import { transformFilters } from '@/fsd/shared/ui/static/js/transformFilters';

export const transformShipmentsListFilters = (
  filters: Record<string, unknown>
) => {
  const transformedFilters = transformFilters({
    date_from: formatDateToDDMMYYYY(filters.date?.[0]),
    date_to: formatDateToDDMMYYYY(filters.date?.[1]),
    counterparty_ids: filters.counterparty,
    statuses: filters.status,
    organisation_ids: filters.organisation,
    sender_warehouse_ids: filters['warehouse-shipment'],
    destination_warehouse_ids: filters['warehouse-reciever'],
    shipping_methods: filters.shipping_method,
    transport_invoice_number: filters['shipment-number'],
    conducted: filters.conducted,
    product_ids: filters.acceptanceproducts,
  });

  return transformedFilters;
};
